<div #container class="d-flex flex-column flex-fill align-items-stretch"
     [ngClass]="{'mb-0': modalOptions.fullScreen || showInReport, 'card': !showInReport, 'report-view': showInReport}">
    <ng-container>
        <div class="card-header dropdown">
            <h4 class="card-header-title">
                <i class="bi bi-diagram-nested"></i>
                <span *ngIf="options.selectedDays.length !== 1">Energy flow overview</span>
                <span *ngIf="options.selectedDays.length === 1">{{ options.selectedDays[0] }}</span>
                <span class="mx-2 notranslate">–</span>
                <span class="notranslate">{{ measurementName(options.selectedDataType, true) }}</span>
            </h4>
            <button *ngIf="!modalOptions.fullScreen" type="button" class="btn" role="button" (click)="openModal()">
                <i class="bi bi-arrows-angle-expand"></i>
            </button>
            <app-chart-download-button [element]="container"></app-chart-download-button>
            <button type="button" class="btn" role="button" data-bs-toggle="dropdown"
                    data-bs-auto-close="outside" aria-expanded="false">
                <i class="bi bi-three-dots-vertical"></i>
            </button>
            <div class="dropdown-menu" style="z-index: 1050;">
                <div class="dropdown-item" *ngIf="perSquareMeterEnabled">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" [id]="getInputId('showBySquareMeter')"
                               [ngModel]="options.showBySquareMeter" (ngModelChange)="showBySquareMeterChange($event)">
                        <label class="form-check-label" [for]="getInputId('showBySquareMeter')">
                            Show by m²
                        </label>
                    </div>
                </div>
                <div class="dropdown-item">
                    <div class="row align-items-center mb-2">
                        <label class="form-check-label col-auto" [for]="getInputId('measurementType')+'-select'">
                            Measurement
                        </label>
                        <app-select class="col px-0" [ngModel]="getSelectedDataType" (ngModelChange)="measurementTypeChanged($event)"
                                    [id]="getInputId('measurementType')" [options]="possibleDataTypes()"
                                    [small]="true" [formatter]="dropdownFormatter">
                        </app-select>
                    </div>
                    <div *ngIf="treeData.size > 1" class="row align-items-center">
                        <label class="form-check-label col-auto" for="treeSelect">Connection</label>
                        <app-select class="col px-0" [ngModel]="selectedTreeKey" (ngModelChange)="onTreeChanged($event)"
                                [id]="getInputId('treeSelect')" [options]="treeOptions" [small]="true">
                        </app-select>
                    </div>
                    <div *ngIf="tagFilters && (tagFilters | keyvalue).length > 0">
                        <hr/>
                        <div><h4 class="dropdown-header px-0">Categories</h4></div>
                        <div class="row align-items-center mb-2"
                             *ngFor="let category of (tagFilters | keyvalue)">
                            <label class="form-check-label col-auto">{{ category.key }}</label>
                            <app-select class="col px-0" [ngModel]="selectedTagFilters[category.key]"
                                        (ngModelChange)="onTagFilterChanged(category.key, $event)"
                                        [options]="category.value" [nullOption]="true"  [small]="true">
                            </app-select>
                        </div>
                    </div>
                </div>
            </div>
            <button *ngIf="modalOptions.fullScreen" type="button" class="btn-close" data-bs-dismiss="modal"
                    aria-label="Close" (click)="closeModal()"></button>
        </div>
    </ng-container>
    <div class="chart-body pt-0 d-flex flex-fill align-items-stretch overflow-auto"
         [ngClass]="{'p-0': true, 'card-body': !showInReport}">
        <ng-container *ngIf="showInReport else notInReport">
            <ng-container [ngTemplateOutlet]="chart"></ng-container>
        </ng-container>
        <ng-template #notInReport>
            <ng-container [ngTemplateOutlet]="chart"></ng-container>
        </ng-template>
    </div>
</div>
<ng-template #chart>
    <div class="w-100">
        <div class="row g-1">
            <div class="col-12"   style="height: 700px;">
                <div class="chart-wrapper xl-content"  *ngIf="chartOptions.get(selectedTreeKey) as opt">
                    <app-tree-chart
                            [options]="opt"
                            [chartKey]="selectedTreeKey"
                            (chartInit)="onChartInit($event.instance, $event.key)"
                            (chartClick)="handleChartClick($event)">
                    </app-tree-chart>
                </div>
            </div>
        </div>
    </div>
</ng-template>
